import isClarksonsEntity from '_legacy/data/isClarksonsEntity';
import { cpDateHeading } from '../fixtures/FixtureHeadings';
import store from 'store';

export interface GroupHeader {
    colIds: string[];
    datasetIds: number[];
    textResolver: (value: {}) => string;
}

export const getGroupingText = (value: any, groupHeaders: GroupHeader[]) => {
    const groupCount = value?.node?.allChildrenCount;
    const defaultText = value.value + ` (${groupCount})`;
    if (groupHeaders.length === 0) {
        return defaultText;
    }
    const datasetId = store.getState().user.group?.datasetId ?? -1;

    const groupHeader = groupHeaders.find((header) =>
        groupHeaderMatch(header, value, datasetId)
    );

    return groupHeader?.textResolver(value) ?? defaultText;
};

const groupHeaderMatch = (
    header: GroupHeader,
    value: any,
    datasetId: number
) => {
    const colIdsEmptyOrIncluded =
        header.colIds.length === 0 || header.colIds.includes(value?.node.field);
    const datasetsEmptyOrIncluded =
        header.datasetIds.length === 0 || header.datasetIds.includes(datasetId);

    return colIdsEmptyOrIncluded && datasetsEmptyOrIncluded;
};

const getCpDateCustomHeader = (value) => {
    const groupCount = value?.node?.allChildrenCount;
    return (
        value.value +
        ` (${
            value?.node?.childrenAfterFilter?.filter((x) =>
                isClarksonsEntity(x.data)
            ).length
        } CLK/${groupCount} TOTAL)`
    );
};

export const customFixtureGroupHeaders: GroupHeader[] = [
    {
        colIds: [cpDateHeading.colId],
        datasetIds: [],
        textResolver: getCpDateCustomHeader,
    },
];

export const customOrderGroupHeaders: GroupHeader[] = [];
